<h1 mat-dialog-title [translate]="'UI.PrintSettings'" class="flex-title cf-flex-row cf-justify-content-start cf-align-items-center"></h1>

<mat-dialog-content>
  @if ((isLoading$ | async) === false) {
    <form
      id="printForm"
      class="form cf-flex-1 cf-flex-column cf-justify-content-start cf-align-items-start"
      [formGroup]="form"
      (ngSubmit)="submit()"
    >
      <div class="full-width cf-flex-row cf-flex-column-xs cf-flex-column-sm">
        <h2 style="width: 680px" class="cf-flex-nowrap" [translate]="'UI.Output'"></h2>
        <div class="cf-justify-content-start cf-align-items-center">
          <mat-radio-group
            class="form-field cf-flex-row cf-justify-content-start cf-align-items-center cf-gap-20"
            [id]="outputTypes"
            formControlName="outputTypes"
          >
            @for (outputType of printSettings?.OutputTypes; track $index) {
              <mat-radio-button [value]="outputType.Value">{{ outputType.TitleTextId | translate }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
        <div class="form-field cf-align-items-center cf-flex-nowrap" style="padding-left: 230px">
          <mat-checkbox class="print-sections-checkbox" [id]="isSimulationReport" formControlName="isSimulationReport">{{
            'Print.Simulation' | translate
          }}</mat-checkbox>
        </div>
      </div>
      <app-border class="full-width"></app-border>
      <div class="full-width cf-flex-row cf-flex-column-xs cf-flex-column-sm">
        <h2 class="cf-flex-20-percent" [translate]="'UI.PrintSections'"></h2>
        <div
          class="cf-flex-1 cf-flex-row cf-flex-wrap cf-justify-content-start cf-align-items-center cf-flex-80-percent cf-gap-10"
          formGroupName="printSections"
          style="padding-left: 24px"
        >
          @for (TitleTextId of printSectionKeys; track TitleTextId) {
            <mat-checkbox class="print-sections-checkbox" [id]="TitleTextId" [formControlName]="TitleTextId">{{
              TitleTextId | translate
            }}</mat-checkbox>
          }
        </div>
      </div>
      <app-border class="full-width"></app-border>

      <div class="full-width parent-overflow full-width cf-flex-row cf-flex-column-xs cf-flex-column-sm">
        <h2 [translate]="'UI.Print'" class="sticky-header cf-flex-20-percent"></h2>
        <div class="full-width child-overflow cf-flex-1">
          <mat-table class="flex-print-table" [dataSource]="dataSource">
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? toggleAllSelections() : null"
                  [checked]="tableSelection?.hasValue() && isAllSelected"
                  [indeterminate]="tableSelection?.hasValue() && !isAllSelected"
                >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let ahu">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? tableSelection.toggle(ahu) : null"
                  [checked]="tableSelection.isSelected(ahu)"
                  [disabled]="!ahu.CanSelect"
                >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="unitCode">
              <mat-header-cell *matHeaderCellDef [translate]="'Ahu.UnitCode'"></mat-header-cell>
              <mat-cell *matCellDef="let ahu">
                <div [ngClass]="{ disabled: !ahu.CanSelect }">{{ ahu.UnitCode | translate }}</div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef [translate]="'Ahu.Description'"></mat-header-cell>
              <mat-cell *matCellDef="let ahu">
                <div [ngClass]="{ disabled: !ahu.CanSelect }">{{ ahu.Description | translate }}</div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="state">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let ahu">
                <app-calculated-icon [state]="ahu.State" [showTooltip]="true"></app-calculated-icon>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="['select', 'unitCode', 'description', 'state']; sticky: true"></mat-header-row>
            <mat-row
              *matRowDef="let ahu; columns: ['select', 'unitCode', 'description', 'state']"
              (click)="toggleRowSelection(ahu)"
              [ngClass]="{ clickable: ahu.CanSelect }"
            ></mat-row>
          </mat-table>
        </div>
      </div>
    </form>
  } @else {
    <div class="spinner cf-flex-1 cf-flex-column cf-justify-content-center cf-align-items-center">
      <app-spinner></app-spinner>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if ((isLoading$ | async) === false) {
    <div class="buttons cf-flex-row cf-justify-content-end cf-align-items-center cf-gap-10">
      <button type="button" mat-button (click)="cancel()" [disabled]="isLoading$ | async">
        <span>{{ 'UI.Cancel' | translate | uppercase }}</span>
      </button>
      <button
        form="printForm"
        type="submit"
        mat-raised-button
        class="primary-button icon-left"
        [disabled]="!form.valid || (isLoading$ | async) || !(tableSelection?.selected.length > 0)"
      >
        <mat-icon aria-hidden="false" aria-label="pdf icon" svgIcon="file-pdf"></mat-icon>
        <span>{{ 'UI.PrintPdf' | translate | uppercase }}</span>
      </button>
    </div>
  }
</mat-dialog-actions>
